module.exports = __webpack_public_path__ + "img/Mask_group.d310c70c.png";